import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import SEO from '../seo/SEO';
import { NAV_LINKS, RESEARCH_SUPPORT_BASE, SEO_DEFAULTS } from '../../constants/researchSupport';

function ResearchSupportLayout({ seo = SEO_DEFAULTS }) {
  return (
    <div className="max-w-6xl mx-auto pb-16">
      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        pathname={seo.pathname}
      />

      <header className="mb-10 border-b border-gray-200 pb-8">
        <p className="text-sm font-medium text-iof uppercase tracking-wide mb-2">
          Undergraduate Research Publication Support Initiative
        </p>
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
          Research Support
        </h1>
        <p className="text-gray-600 max-w-3xl leading-relaxed">
          A dedicated pathway for undergraduate students and recent graduates to submit research,
          receive structured publication support, and track progress through review.
        </p>
      </header>

      <nav
        className="flex flex-wrap gap-2 mb-10"
        aria-label="Research Support section"
      >
        {NAV_LINKS.map(({ path, label, end }) => (
          <NavLink
            key={path}
            to={path}
            end={end}
            className={({ isActive }) =>
              `px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-iof text-white'
                  : 'bg-white border border-gray-200 text-gray-700 hover:border-iof hover:text-iof'
              }`
            }
          >
            {label}
          </NavLink>
        ))}
        <NavLink
          to={`${RESEARCH_SUPPORT_BASE}/my-submissions`}
          className={({ isActive }) =>
            `px-4 py-2 rounded-full text-sm font-medium transition-colors ${
              isActive
                ? 'bg-iof-dark text-white'
                : 'bg-iof/10 text-iof-dark hover:bg-iof/20'
            }`
          }
        >
          My Submissions
        </NavLink>
      </nav>

      <Outlet />
    </div>
  );
}

export default ResearchSupportLayout;
